import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { PlanningSegmentStore } from "@app/services/store/planning-segment-store";
import { MatSelect } from "@angular/material/select";
import { Store } from "@ngrx/store";
import { BaseTimeNavigablePageComponent } from "@app/view/shared/base-pages/base-time-navigable-page/base-time-navigable-page.component";
import { SolverService } from "@app/services/rest/solver.service";
import { BendableLongScore } from "@app/models/dto/bendable-long-score";
import { MeetingEditorComponent } from "@app/view/planning/meeting-editor/meeting-editor.component";
import { MatDialog } from "@angular/material/dialog";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { DateNavigatorComponent } from "../../shared/date-navigator/date-navigator.component";
import { MatInput } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { MatCard } from "@angular/material/card";
import { ScheduleViewerComponent } from "../schedule-viewer/schedule-viewer.component";
import { MomentModule } from "ngx-moment";

@Component({
  selector: "app-resource-schedule-list",
  templateUrl: "./resource-schedule-list.component.html",
  styleUrls: ["./resource-schedule-list.component.scss"],
  imports: [
    MatToolbar,
    MatToolbarRow,
    DateNavigatorComponent,
    MatInput,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatCheckbox,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatCard,
    MatButton,
    ScheduleViewerComponent,
    MomentModule
  ]
})
export class ResourceScheduleListComponent
  extends BaseTimeNavigablePageComponent
  implements OnInit
{
  protected solverService = inject(SolverService);
  protected matDialog = inject(MatDialog);

  @ViewChild("timeFrom", { static: false }) timeFrom: any;
  @ViewChild("timeFromSelect", { static: false }) timeFromSelect: MatSelect;
  @ViewChild("timeTo", { static: false }) timeTo: any;
  @ViewChild("timeToSelect", { static: false }) timeToSelect: MatSelect;

  public score: Partial<BendableLongScore>;

  constructor() {
    super();

    setInterval(() => {
      this.time = Date.now();
    }, 1000);
    this.solverService.updateStream.subscribe((value) => {
      this.score = value.score;
    });
    this.solverService.status().then();
  }

  columnsChanged() {
    this.saveLayout();
  }

  activeOnlyChanged(checked: boolean) {
    if (this.scheduleViewer instanceof ScheduleViewerComponent) {
      this.scheduleViewer.setActiveOnly(checked);
      this.saveLayout();
    }
  }

  openMeetingForm() {
    this.matDialog.open(MeetingEditorComponent, {
      hasBackdrop: true,
      panelClass: "toolbar-popup-dialog",
      data: { currentDate: this.selectedDate }
    });
  }
}
